import React from 'react';

import logo from '../../../assets/images/pmag.png';

import './styles.css';

export default function Header() {
  return (
    <header className="no-print">
      <div className="container">
        <img src={logo} alt="SECRETARIA DE MEIO AMBIENTE" height="60"/>
        <strong>Requerimento de Licença Ambiental Declaratória</strong>
      </div>
    </header>
  )
}
